import script from './components/alpha/index.js';
import script$1 from './components/checkboard/index.js';
import script$2 from './components/chrome/index.js';
import script$3 from './components/compact/index.js';
import script$4 from './components/editable-input/index.js';
import script$5 from './components/grayscale/index.js';
import script$6 from './components/hue/index.js';
import script$7 from './components/material/index.js';
import script$8 from './components/photoshop/index.js';
import script$9 from './components/saturation/index.js';
import script$a from './components/sketch/index.js';
import script$b from './components/slider/index.js';
import script$c from './components/swatches/index.js';
import script$d from './components/twitter/index.js';
import 'vue';
import './style-inject.es-746bb8ed.js';
import './utils/compoent.js';
import './defaultConfig.js';
import './mixin/color.js';
import '@ctrl/tinycolor';
import './utils/utils.js';
import 'material-colors';

/* Do not modify the automatically generated code */

const components = [
  script,
  script$1,
  script$2,
  script$3,
  script$4,
  script$5,
  script$6,
  script$7,
  script$8,
  script$9,
  script$a,
  script$b,
  script$c,
  script$d,
];

export { script as Alpha, script$1 as Checkboard, script$2 as Chrome, script$3 as Compact, script$4 as EditableInput, script$5 as Grayscale, script$6 as Hue, script$7 as Material, script$8 as Photoshop, script$9 as Saturation, script$a as Sketch, script$b as Slider, script$c as Swatches, script$d as Twitter, components };
